export const races = [
    { code: 'wh', label: 'White'},
    { code: 'ba', label: 'Black or African American' },
    { code: 'ai', label: 'American Indian or Alaska Native' },
    { code: 'as', label: 'Asian' },
    { code: 'nh', label: 'Native Hawaiian or Other Pacific Islander' },
];
